export const chartDownloadImageScaleFactor = 4;

export const enableCustomReports = true;
